/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Mapdescription1Inputs */

const zh_print_mapdescription1 = /** @type {(inputs: Print_Mapdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`描述`)
};

const en_print_mapdescription1 = /** @type {(inputs: Print_Mapdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const es_print_mapdescription1 = /** @type {(inputs: Print_Mapdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción`)
};

/**
* | output |
* | --- |
* | "Description" |
*
* @param {Print_Mapdescription1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const print_mapdescription1 = /** @type {((inputs?: Print_Mapdescription1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Mapdescription1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_print_mapdescription1(inputs)
	if (locale === "en") return en_print_mapdescription1(inputs)
	return es_print_mapdescription1(inputs)
});
export { print_mapdescription1 as "print_mapDescription" }